export default "__VITE_ASSET__Dt9yOHdi__"